import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

export enum eDepartureTimeOptions {
  NOW,
  DEPART,
  ARRIVAL,
}

export const DEPARTURE_TIME_OPTIONS: SelectOption<eDepartureTimeOptions>[] =
  [
    {
      label: 'צא עכשיו',
      value: eDepartureTimeOptions.NOW,
    },
    {
      label: 'יציאה ב...',
      value: eDepartureTimeOptions.DEPART,
    },
    {
      label: 'הגעה ב...',
      value: eDepartureTimeOptions.ARRIVAL,
    },
  ];
